module.exports = __webpack_public_path__ + "img/ar_view_down_s.808de5ac.svg";